<template>
    <span>
        <slot></slot>
    </span>
</template>

<script>
/*
    TODO: 
        Add responsive options
        Add support for custom font load testing

*/
export default {
    props: {
        targetLineCount: {
            default: 1,
            type: Number,
        },
        unit: {
            default: 'rem',
            type: String,
        },
        min: {
            default: 1,
            type: Number,
        },
        max: {
            default: 2,
            type: Number
        }
    },
    data() {
        return {
            observer: null,
        }
    },
    methods: {
        calculate() {
            let element = this.$el;

            element.style.display = 'inline-block';
            element.style.lineHeight = '1px';

            // Keep trying until it fits
            let fontSize = this.max;
            let stepSize = (this.unit === 'px') ? 1 : 0.05;

            // element.style.fontSize = fontSize + this.unit;

            while (element.offsetHeight > this.targetLineCount && fontSize > this.min) {
                fontSize -= stepSize;
                // element.style.fontSize = fontSize + this.unit;
            }

            element.style.display = null;
            element.style.lineHeight = null;
        }
    },
    mounted() {
        this.calculate();

        if ('MutationObserver' in window && this.observer === null) {
            // Create the observer (and what to do on changes...)
            this.observer = new MutationObserver(this.calculate);

            // Setup the observer
            this.observer.observe(
                this.$el, {
                    subtree: true,
                    characterData: true
                }
            );
        }
    },
    beforeDestroy: function () {
        // Clean up
        this.observer.disconnect();
    }
}

</script>


// WEBPACK FOOTER //
// src/app/components/fit-text.vue